module.exports = __webpack_public_path__ + "img/신촌 소고기.904aa30e.png";